import type { ModalCopy } from "@circle-react-shared/TrixEditor/InlineModalSelector/ModalCopy";
import { TextInput } from "@circleco/compass/components/TextInput";
import type { FormEvent, ReactNode } from "react";
import { useState } from "react";

import { t } from "@/i18n-js/instance";

import { EMBED_FORM_ID } from "./constants";

export interface EmbedPanelProps {
  copy: ModalCopy;
  description: ReactNode;
  onClose: () => void;
  onSubmitUrl: (url: string) => void | Promise<void>;
}

export const EmbedPanel = ({
  copy,
  description,
  onClose,
  onSubmitUrl,
}: EmbedPanelProps) => {
  const [url, setUrl] = useState("");

  const onSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    event.stopPropagation();
    if (!url) return;
    onClose();
    await onSubmitUrl(url);
  };

  return (
    <form id={EMBED_FORM_ID} onSubmit={onSubmit}>
      <TextInput
        label={t("trix_editor.embed_form.url_label")}
        value={url}
        placeholder={copy.embedPlaceholder}
        description={description}
        onChange={event => setUrl(event.target.value)}
      />
    </form>
  );
};
